import React from 'react';
import { useAuth } from '../contexts/auth';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
    element: React.FunctionComponentElement<any>;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({element}) => {
    const { isAuthenticated } = useAuth();
    const location = useLocation(); // Use the useLocation hook to get the current location

    return isAuthenticated ? (
        element
    ) : (
        <Navigate to="/login" replace state={{ from: location }} />
    );
};

export default ProtectedRoute;